import { useEffect } from "react";
import { useHistory } from "react-router-dom";

type UseBlockNavigationOptions = {
  isEnabled: boolean;
};

/**
 * Blocks navigation (browser back button and programmatic navigation)
 * and shows the native browser prompt when navigation is attempted.
 */
export function useBlockNavigation(options: UseBlockNavigationOptions) {
  const history = useHistory();

  useEffect(() => {
    if (!options.isEnabled) return undefined;

    const unblock = history.block(() => {
      if (options.isEnabled) {
        /**  Returning a string shows the native browser prompt
         * The string message is ignored by modern browsers, but returning
         * a truthy value triggers the prompt
         */
        return "You have unsaved changes. Are you sure you want to leave?";
      }

      return undefined;
    });

    return () => {
      unblock();
    };
  }, [options.isEnabled, history]);
}
